import type { App } from 'vue';
import { createPinia } from 'pinia';

const store = createPinia();

/**
 * setupStore
 */
export function setupStore(app: App<Element>): void {
    app.use(store);
}

export { store };
